import * as yup from 'yup';

const getCharacterValidationError = (str) => `Your password must have at least 1 ${str} character`;

export const validationSchema = yup.object({
  email: yup.string().email('Email is incorrect').required('Email is required'),
  password: yup.string().min(8, 'Password must have at least 8 characters').matches(/[0-9]/, getCharacterValidationError('digit')).matches(/[a-z]/, getCharacterValidationError('lowercase')).required('Password is required'),
});